import request from "../../../../helper/request";

const clientApi = {
  getClientList: (params) => {
    return request.get("/admin/clients", {
      params
    });
  },

  getAllClientCities: (params) => {
    return request.get("/admin/clients/client-cities");
  },

  createClient: (data) => {
    return request.post("/admin/clients", data);
  },

  getClient: (id) => {
    return request.get(`/admin/clients/${id}`);
  },

  updateClient: (data) => {
    const id = data.id;
    delete data.id;
    return request.patch(`/admin/clients/${id}`, data);
  },

  deleteClient: (data) => {
    return request.delete(`/admin/clients/${data.id}`);
  },

  blockClient: (clientId, blockReason) => {
    return request.patch(`/admin/clients/${clientId}/block`, { blockReason });
  },

  unblockClient: (clientId, blockReason) => {
    return request.patch(`/admin/clients/${clientId}/unblock`, { blockReason });
  },

  // Payment Methods Management
  getClientPaymentMethods: (clientId) => {
    return request.get(`/admin/clients/${clientId}/payment-methods`);
  },

  deleteClientPaymentMethod: (clientId, methodId) => {
    return request.delete(`/admin/clients/${clientId}/payment-methods/${methodId}`);
  },

  setClientDefaultPaymentMethod: (clientId, methodId) => {
    return request.post(
      `/admin/clients/${clientId}/payment-methods/${methodId}/set-default`
    );
  },

  createClientPortalSession: (clientId) => {
    return request.post(
      `/admin/clients/${clientId}/payment-methods/create-portal-session`
    );
  },

  createClientAddMethodSession: (clientId) => {
    return request.post(`/admin/clients/${clientId}/payment-methods/add-method-session`);
  },

  createClientPaymentIntent: (clientId) => {
    return request.post(`/admin/clients/${clientId}/payment-methods/create-intent`);
  },

  // Entitlements Management
  getEntitlements: () => {
    return request.get("/admin/billing/entitlements");
  },

  getClientEntitlements: (clientId) => {
    return request.get(`/admin/billing/client-entitlements/${clientId}`);
  },

  updateClientEntitlement: (clientId, entitlementId, isActive, settings) => {
    return request.put("/admin/billing/client-entitlements", {
      clientId,
      entitlementId,
      isActive,
      settings
    });
  },

  // Admin Entitlement CRUD
  getEntitlementById: (id) => {
    return request.get(`/admin/billing/entitlements/${id}`);
  },

  createEntitlement: (data) => {
    return request.post("/admin/billing/entitlements", data);
  },

  updateEntitlement: (id, data) => {
    return request.put(`/admin/billing/entitlements/${id}`, data);
  },

  deleteEntitlement: (id) => {
    return request.delete(`/admin/billing/entitlements/${id}`);
  },

  activateEntitlement: (id) => {
    return request.post(`/admin/billing/entitlements/${id}/activate`);
  },

  // Sync tier entitlements to client
  syncTierEntitlements: (clientId) => {
    return request.post(`/admin/clients/${clientId}/sync-tier-entitlements`);
  }
};

export default clientApi;
